import http from "../http-common"

class FooterMenuService {
    getAllFooterMenu() {
        return http.get("/master-page/footer-menu")
    }
}


export default new FooterMenuService();